export default __webpack_public_path__ + "static/CertifiedLocalGovernmentCLG-a8e59b831ddceebb24a33655694805a8.jpg";